import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  cashierPreferencesOptionTitleHeader: {
    paddingTop: '6.641vh',
  },
  zoomLevelPadding: {
    paddingTop: '6.771vh',
  },
  radioButtonFlex: {
    paddingTop: '1.875vh',
    flexDirection: 'row',
    display: 'inline-flex',
    alignItems: 'center',
  },
  columnFlex: {
    alignSelf: 'flex-end',
  },
  lowerCase: {
    textTransform: 'none',
  },
  zoomLevelBorder: {
    height: '44.012vh',
    border: `1px solid ${themeColor.lightgray}`,
    borderRadius: '2px',
  },
}));
